import SignUpMailModal from "./SignUpMailModal";

export default SignUpMailModal;
